module.exports = __webpack_public_path__ + "img/criptan-dark.83146326.png";